export const ShkolnayaData = [
    {
        title: "дом №13",
        year: '1964',
        floor: "4",
        apartment: "44",
        quantityLC: "45",
        livingArea: "2014,1",
        notLivinigArea: "нет",
        commonProperty: "148,2",
        type: "многоэтажный жилой дом",
        level: "ХВС, ГВС, отопление, канализация, газоснабжение, электроснабжение",
        technicalSupport: "нет",
        contractURL: 'shkolnaya/sofrino_shkolnaya_5_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }
]